import React from 'react';
import { FadeIn } from './FadeIn';
import { XIcon } from 'lucide-react';
const approaches = [{
  title: 'Analgésicos Comunes',
  desc: 'Solo enmascaran el síntoma, pero no detienen la dilatación de los vasos sanguíneos que causa el latido.'
}, {
  title: 'Reposar en la Oscuridad',
  desc: 'Totalmente imposible cuando tienes que cumplir con una jornada laboral o cuidar a tus hijos.'
}, {
  title: 'Dietas Restrictivas',
  desc: 'Son lentas y no te ayudan en el momento exacto en que la crisis está rompiendo.'
}, {
  title: 'Abuso de Cafeína',
  desc: "Termina creando una 'migraña crónica por fármacos' de la que es casi imposible salir."
}];
export function FailedApproaches() {
  return <section className="py-20 px-6 bg-navy-800" data-id="element-14">
      <div className="max-w-5xl mx-auto" data-id="element-15">
        <FadeIn data-id="element-16">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-17">
            Por Qué lo que Has Intentado{' '}
            <span className="text-red-400" data-id="element-18">No Funciona</span>
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-19">
          {approaches.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-20">
              <div className="bg-navy-900 p-6 rounded-xl border border-slate-700/50 flex items-start" data-id="element-21">
                <div className="bg-red-500/10 p-2 rounded-lg mr-4 flex-shrink-0" data-id="element-22">
                  <XIcon className="w-6 h-6 text-red-500" data-id="element-23" />
                </div>
                <div data-id="element-24">
                  <h3 className="text-lg font-semibold text-white mb-2 line-through decoration-red-500/50" data-id="element-25">
                    {item.title}
                  </h3>
                  <p className="text-slate-400 text-sm leading-relaxed" data-id="element-26">
                    {item.desc}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}